module.exports = __webpack_public_path__ + "img/workContents03-04.df87dfa5.gif";